module.exports = require('./dist/style')



//////////////////
// WEBPACK FOOTER
// ../~/styled-jsx/style.js
// module id = 79
// module chunks = 1